import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { Sentry, sentryEnabled } from './sentry'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import BandeauStaging from './components/BandeauStaging.jsx'

// En prod (DSN present), on enveloppe l'app dans l'ErrorBoundary Sentry pour
// remonter les crashs top-level. En dev, on rend App directement → overlay
// d'erreur Vite preserve, comportement inchange (strictement additif).
// NB : le CockpitErrorBoundary interne (ClientJourneyPage) reste intact ; ce
// boundary-ci est un filet global au-dessus, il ne le remplace pas.
// Filet global : l'ErrorBoundary maison enveloppe TOUJOURS l'app pour qu'aucun
// crash de rendu ne produise un ecran noir — elle AFFICHE le message d'erreur
// reel (diagnostic). En prod, on l'imbrique dans Sentry.ErrorBoundary pour
// aussi remonter le crash. En dev (pas de DSN), la boundary maison suffit.
const tree = sentryEnabled ? (
  <Sentry.ErrorBoundary
    fallback={
      <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif', textAlign: 'center' }}>
        <p>Une erreur inattendue est survenue.</p>
        <button type="button" onClick={() => window.location.reload()}>
          Recharger
        </button>
      </div>
    }
  >
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Sentry.ErrorBoundary>
) : (
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
)

// Le bandeau est HORS de l'ErrorBoundary, volontairement : un crash de
// l'application ne doit pas emporter l'avertissement. C'est justement quand
// l'ecran est casse qu'on ne sait plus ou l'on se trouve.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BandeauStaging />
    {tree}
  </StrictMode>,
)

// V30/V40 : enregistre le service worker PWA en prod web uniquement
// — Capacitor (app native iOS/Android) n'a pas besoin du SW et le path ./sw.js
// n'est pas résolvable dans la WebView → on skip.
const isNativeCapacitor = typeof window !== 'undefined' && !!window.Capacitor?.isNativePlatform?.();
if ('serviceWorker' in navigator && import.meta.env.PROD && !isNativeCapacitor) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(err => {
      console.warn('[SW] registration failed:', err?.message);
    });
  });
}
